import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class MonitorManage {
  // 新增视频监控
  static async insertMonitor(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Video_Monitor/video_monitor', payload)
    )
    return Callback(err, res)
  }
  // 编辑视频监控
  static async updateMonitor(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/Video_Monitor/video_monitor', payload)
    )
    return Callback(err, res)
  }
  // 获取视频监控列表
  static async getMonitorList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Video_Monitor/query_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 删除视频监控
  static async deleteMonitor(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/Video_Monitor/video_monitor', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 导入视频监控
  static async uploadMonitor(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Video_Monitor/video_monitor/import', payload.formData)
    )
    return Callback(err, res)
  }
  // 导出视频监控
  static async exportExcel(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/Video_Monitor/export_list', payload))
    return Callback(err, res)
  }
  // 获取视频监控列表
  static async getMonitorRelationList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Video_Monitor_Relation/query_list_video_monitor_pull_down?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取视频监控关联列表
  static async getRelationList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Video_Monitor_Relation/query_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 添加关联
  static async insertRelation(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Video_Monitor_Relation/video_monitor_relation', payload)
    )
    return Callback(err, res)
  }
  // 更新关联
  static async updateRelation(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/Video_Monitor_Relation/video_monitor_relation', payload)
    )
    return Callback(err, res)
  }
  // 更新关联
  static async deleteRelation(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/Video_Monitor_Relation/video_monitor_relation', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
}
